export const iconFontAwesomeHumanitarianTruckFront = (
	<i className="fa-solid fa-truck-front"></i>
);
